/**
 * Chain -> block explorer URL mapping (single source of truth).
 *
 * Shared by PaymentDetails (BuyTokensModal) and PricingPage so both render a
 * correct per-chain explorer link instead of hardcoding etherscan.io for every
 * chain (RULE #-2: one implementation).
 */

const CHAIN_EXPLORER_URLS: Record<string, string> = {
  ethereum: 'https://etherscan.io/address/',
  binance: 'https://bscscan.com/address/',
  solana: 'https://solscan.io/account/',
  tron: 'https://tronscan.org/#/address/',
};

export function getExplorerUrl(chain: string, address: string): string {
  const base = CHAIN_EXPLORER_URLS[chain.toLowerCase()] ?? 'https://etherscan.io/address/';
  return `${base}${address}`;
}
